import api from "@/frontend/api";

export default {
    get: (params) => api.get('search', params),
}